import { c as _c } from "react/compiler-runtime";
// Деталь заявки на возврат — макет «Профиль», кадры «Заявка от 14 мая»:
// на рассмотрении (плашка #F8F8F8 у каждой позиции, чекбоксы + счётчики,
// «Отменить заявку» → полная или частичная отмена), «Верните товар до …»
// (жёлтая #FFECBD), спор (розовая #F9E7E7 «Спор» + фото продавца, «Закрыть
// спор» / «Поддержка»), решение по спору (#F8F8F8 «Решение»), «Вы вернули
// товар» (зелёная #CDF4D3). Крошки «Возвраты › Вкладка › Заявка от …».

import { Skeleton } from "@osmix/ui/skeleton";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router";
import { toast } from "sonner";
import { api, type BuyerReturnDetail, type BuyerReturnTab, type ReturnLine } from "@/api";
import { orderNumber } from "@/components/profile/order-view";
import { ProfilePanel } from "@/components/profile/profile-shell";
import { ReturnDisputeModal } from "@/components/profile/return-dispute-modal";
import { ReturnLineCard } from "@/components/profile/return-line-card";
import { CabinetEmpty, fmtDayMonth, MediaStrip, reviewDaysText } from "@/components/profile/return-parts";
import { ReturnAcceptedModal } from "@/components/profile/return-request-modal";
import { isCancelledByBuyer, RETURN_TAB_LABEL, tabOfReturn } from "@/components/profile/return-status";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useProfile } from "@/store";
export function ProfileReturnPage() {
  const $ = _c(32);
  const {
    returnId: t0
  } = useParams();
  const returnId = t0 === undefined ? "" : t0;
  const [params] = useSearchParams();
  const userId = useProfile(_temp);
  let t1;
  if ($[0] !== returnId || $[1] !== userId) {
    t1 = ["buyer", userId, "returns", "detail", returnId];
    $[0] = returnId;
    $[1] = userId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== returnId) {
    t2 = () => api.cabinet.returnDetail(returnId);
    $[3] = returnId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: t2,
      retry: false
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const detail = useQuery(t3);
  const r = detail.data;
  const [partialDone, setPartialDone] = useState(null);
  const rawTab = params.get("tab");
  const tab = rawTab === "dispute" || rawTab === "archive" || rawTab === "active" ? rawTab : r ? tabOfReturn(r) : "active";
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      label: "\u0412\u043E\u0437\u0432\u0440\u0430\u0442\u044B",
      to: "/profile/returns"
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = RETURN_TAB_LABEL[tab];
  const t6 = tab === "active" ? "/profile/returns" : `/profile/returns?tab=${tab}`;
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = {
      label: t5,
      to: t6
    };
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = r ? `Заявка от ${fmtDayMonth(r.createdAt)}` : "\u0417\u0430\u044F\u0432\u043A\u0430";
  let t9;
  if ($[12] !== t8) {
    t9 = {
      label: t8
    };
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7 || $[15] !== t9) {
    t10 = [t4, t7, t9];
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== detail.isPending || $[18] !== r) {
    t11 = detail.isPending ? <Skeleton className="h-[333px] rounded-[16px]" /> : !r ? <CabinetEmpty title={"\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430"} hint={"\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u043E\u043D\u0430 \u0431\u044B\u043B\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430."} /> : <ReturnDetailBody key={`${r.id}-${r.updatedAt}-${r.lines.filter(_temp2).length}-${r.requestedRefund}-${r.dispute?.status ?? ""}`} r={r} onPartialDone={setPartialDone} />;
    $[17] = detail.isPending;
    $[18] = r;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = Boolean(partialDone);
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = o => {
      if (!o) {
        setPartialDone(null);
      }
    };
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = partialDone?.photo;
  const t15 = partialDone?.quantity ?? 1;
  let t16;
  if ($[21] !== r) {
    t16 = r ? reviewDaysText(r.createdAt, r.dueAt) : null;
    $[21] = r;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t12 || $[24] !== t14 || $[25] !== t15 || $[26] !== t16) {
    t17 = <ReturnAcceptedModal open={t12} onOpenChange={t13} title={"\u0412\u0430\u0448\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u0443\u044E \u043E\u0442\u043C\u0435\u043D\u0443 \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u043F\u0440\u0438\u043D\u044F\u0442\u0430!"} photo={t14} quantity={t15} days={t16} />;
    $[23] = t12;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t10 || $[29] !== t11 || $[30] !== t17) {
    t18 = <ProfilePanel crumbs={t10}>{t11}{t17}</ProfilePanel>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  return t18;
}
function _temp2(l) {
  return !l.cancelledAt;
}
function _temp(s) {
  return s.user?.id ?? "guest";
}
function Plate(t0) {
  const $ = _c(8);
  const {
    tone,
    children
  } = t0;
  const t1 = tone === "gray" && "bg-[#F8F8F8]";
  const t2 = tone === "yellow" && "bg-[#FFECBD]";
  const t3 = tone === "pink" && "bg-[#F9E7E7]";
  const t4 = tone === "green" && "bg-[#CDF4D3]";
  let t5;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = cn("rounded-[12px] px-3 py-3 text-[14px] leading-[18px] text-[#1F1F1F]", t1, t2, t3, t4);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children || $[6] !== t5) {
    t6 = <div className={t5}>{children}</div>;
    $[5] = children;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}
function ReturnDetailBody({
  r,
  onPartialDone
}: {
  r: BuyerReturnDetail;
  onPartialDone: (done: {
    photo?: string | null;
    quantity: number;
  }) => void;
}) {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const userId = useProfile(s => s.user?.id ?? "guest");
  const active = r.lines.filter(l => !l.cancelledAt);
  const lines = active.length ? active : r.lines;
  const cancellable = !r.dispute && (r.status === "requested" || r.status === "approved");
  const [selected, setSelected] = useState<Set<string>>(() => new Set(cancellable ? active.map(l_0 => l_0.id) : lines.map(l_1 => l_1.id)));
  const [cancelQty, setCancelQty] = useState<Record<string, number>>({});
  const [busy, setBusy] = useState(false);
  const [disputeOpen, setDisputeOpen] = useState(false);
  const buyerMedia = r.attachments.filter(a => a.author === "buyer");
  const sellerMedia = r.attachments.filter(a_0 => a_0.author === "seller");
  const mediaFor = (l_2: ReturnLine, i: number) => l_2.attachments.length ? l_2.attachments : i === 0 ? buyerMedia : [];
  const refresh = () => qc.invalidateQueries({
    queryKey: ["buyer", userId]
  });
  const cancel = async () => {
    const chosen = active.filter(l_3 => selected.has(l_3.id));
    if (chosen.length === 0) return;
    const qtyOf = (l_4: ReturnLine) => Math.min(l_4.quantity, cancelQty[l_4.id] ?? l_4.quantity);
    const keep = active.filter(l_5 => !selected.has(l_5.id) || qtyOf(l_5) < l_5.quantity);
    const reduce = active.filter(l_6 => selected.has(l_6.id) && qtyOf(l_6) < l_6.quantity).map(l_7 => ({
      lineId: l_7.id,
      quantity: qtyOf(l_7)
    }));
    setBusy(true);
    try {
      await api.cabinet.cancelReturn(r.id, keep.map(l_8 => l_8.id), reduce);
      if (keep.length === 0) {
        await refresh();
        toast.success("Заявка на возврат отменена");
        navigate("/profile/returns?tab=archive");
      } else {
        onPartialDone({
          photo: chosen[0]?.photo,
          quantity: chosen.reduce((s_0, l_9) => s_0 + qtyOf(l_9), 0)
        });
        await refresh();
      }
    } catch (e) {
      toast.error(e instanceof Error ? e.message : "Не удалось отменить заявку");
    } finally {
      setBusy(false);
    }
  };
  const closeDispute = async () => {
    setBusy(true);
    try {
      await api.cabinet.closeDispute(r.id);
      toast.success("Спор закрыт");
      await refresh();
    } catch (e_0) {
      toast.error(e_0 instanceof Error ? e_0.message : "Не удалось закрыть спор");
    } finally {
      setBusy(false);
    }
  };
  const support = () => navigate(r.dispute?.supportThreadId ? `/chats?conversation=${encodeURIComponent(r.dispute.supportThreadId)}` : "/profile/support");
  const lineCard = (l_10: ReturnLine, i_0: number) => <ReturnLineCard key={l_10.id} line={l_10} brand={l_10.brand || r.shopName} media={mediaFor(l_10, i_0)} selectable={cancellable && !l_10.cancelledAt} showCheck={cancellable || Boolean(r.dispute)} selected={selected.has(l_10.id)} onSelect={v => setSelected(prev => {
    const next = new Set(prev);
    if (v) next.add(l_10.id);else next.delete(l_10.id);
    return next;
  })} cancelQty={cancelQty[l_10.id]} onCancelQty={v_0 => setCancelQty(prev_0 => ({
    ...prev_0,
    [l_10.id]: v_0
  }))} />;
  const days = reviewDaysText(r.createdAt, r.dueAt);
  const sellerRejected = r.status === "rejected" && !r.dispute && !isCancelledByBuyer(r);

  // «Спор»: текст продавца (или ожидание ответа) + его фото.
  const disputeBlock = r.dispute ? <Plate tone={r.dispute.status === "open" ? "pink" : "gray"}>
			<p className="font-semibold">Спор</p>
			<p className="mt-1 text-black">{r.dispute.sellerText || "Продавец ещё не ответил. Площадка подключится к разбору, если ответа не будет."}</p>
			{sellerMedia.length ? <MediaStrip items={sellerMedia} w={38} h={50} className="mt-2" /> : null}
		</Plate> : null;
  return <div className="flex flex-col gap-2.5">
			{/* Номер заказа заявки — короткий, как в «Моих заказах» (правка №13). */}
			<Link to={`/profile/orders/${encodeURIComponent(r.orderId)}`} className="w-fit text-[14px] leading-[18px] text-[#1F1F1F]/48 hover:text-[#1F1F1F]">
				Заказ №{orderNumber(r.orderId, r.orderNumber)}
			</Link>
			{r.status === "requested" && !r.dispute ?
    // На рассмотрении: заголовок статуса 16/20 w600 (строка 40), у каждой
    // позиции своя карточка с плашкой срока (кадр 3945:44608).
    <>
					<h2 className="py-2.5 text-[16px] leading-5 font-semibold tracking-[-0.31px] text-black">На рассмотрении</h2>
					{lines.map((l_11, i_1) => <section key={l_11.id} className="flex flex-col gap-[10px] rounded-[16px] bg-white p-3">
							<Plate tone="gray">
								{days ? `Заявка рассматривается Продавцом в течение ${days} с момента её поступления.` : "Заявка рассматривается Продавцом."}
							</Plate>
							{lineCard(l_11, i_1)}
						</section>)}
				</> : <section className="flex flex-col gap-[10px] rounded-[16px] bg-white p-3">
					{r.dispute && r.dispute.status === "closed" ? <Plate tone="gray">
							<p className="font-semibold">Решение</p>
							<p className="mt-1 text-black">
								{r.dispute.outcome === "buyer" ? "В вашу пользу" : r.dispute.outcome === "seller" ? "В пользу продавца" : r.dispute.outcome === "partial" ? "Частично в вашу пользу" : "Вы закрыли спор"}
							</p>
						</Plate> : null}
					{r.status === "approved" && !r.dispute && r.shipment ? <Plate tone="yellow">
							<p className="font-semibold">Верните товар до {fmtDayMonth(r.shipment.deadlineAt)}</p>
							<p className="mt-1 text-black">Адрес возврата: {r.shipment.address}</p>
							<p className="mt-1 text-black">Рекомендованная служба доставки: {r.shipment.carrier}</p>
							<p className="mt-1 text-black">{r.shipment.refundTargetLabel}</p>
						</Plate> : null}
					{(r.status === "received" || r.status === "refunded") && !r.dispute ? <Plate tone="green">
							<p className="font-semibold">Вы вернули товар</p>
							<p className="mt-1 text-black">
								Продавец принял товар.
								{r.status === "refunded" && r.refundedAt ? ` Деньги возвращены ${fmtDayMonth(r.refundedAt)} на тот счёт, которым была произведена оплата.` : ""}
							</p>
						</Plate> : null}
					{sellerRejected ? <Plate tone="gray">
							<p className="font-semibold">Решение</p>
							<p className="mt-1 text-black">Продавец отклонил заявку{r.resolutionNote ? `: ${r.resolutionNote}` : "."}</p>
						</Plate> : null}
					{isCancelledByBuyer(r) ? <Plate tone="gray">
							<p className="font-semibold">Заявка отменена</p>
						</Plate> : null}
					{lines.map(lineCard)}
					{disputeBlock}
				</section>}

			<div className="mt-2.5 flex flex-wrap gap-2.5">
				{cancellable ? <Button variant="gray" disabled={busy || selected.size === 0} onClick={() => void cancel()}>
						Отменить заявку
					</Button> : null}
				{r.dispute?.status === "open" ? <>
						<Button variant="gray" disabled={busy} onClick={() => void closeDispute()}>
							Закрыть спор
						</Button>
						<Button variant="gray" onClick={support}>
							Поддержка
						</Button>
					</> : null}
				{sellerRejected ? <Button variant="gray" onClick={() => setDisputeOpen(true)}>
						Открыть спор
					</Button> : null}
			</div>

			<ReturnDisputeModal returnId={disputeOpen ? r.id : null} onOpenChange={setDisputeOpen} onOpened={() => {
      setDisputeOpen(false);
      void refresh();
      navigate(`/profile/returns/${encodeURIComponent(r.id)}?tab=dispute`, {
        replace: true
      });
    }} />
		</div>;
}